var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.5C4.70156 0.5 0 5.20156 0 11C0 16.7984 4.70156 21.5 10.5 21.5C16.2984 21.5 21 16.7984 21 11C21 5.20156 16.2984 0.5 10.5 0.5ZM10.5 19.7188C5.68594 19.7188 1.78125 15.8141 1.78125 11C1.78125 6.18594 5.68594 2.28125 10.5 2.28125C15.3141 2.28125 19.2188 6.18594 19.2188 11C19.2188 15.8141 15.3141 19.7187 10.5 19.7188Z",
    fill: "#DB2929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 15.125C9.375 15.4234 9.49353 15.7095 9.7045 15.9205C9.91548 16.1315 10.2016 16.25 10.5 16.25C10.7984 16.25 11.0845 16.1315 11.2955 15.9205C11.5065 15.7095 11.625 15.4234 11.625 15.125C11.625 14.8266 11.5065 14.5405 11.2955 14.3295C11.0845 14.1185 10.7984 14 10.5 14C10.2016 14 9.91548 14.1185 9.7045 14.3295C9.49353 14.5405 9.375 14.8266 9.375 15.125ZM9.9375 12.5H11.0625C11.1656 12.5 11.25 12.4156 11.25 12.3125L11.25 5.9375C11.25 5.83437 11.1656 5.75 11.0625 5.75H9.9375C9.83438 5.75 9.75 5.83437 9.75 5.9375L9.75 12.3125C9.75 12.4156 9.83438 12.5 9.9375 12.5Z",
    fill: "#DB2929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon12);
export default __webpack_public_path__ + "static/media/alert-icon-12.fb034609.svg";
export { ForwardRef as ReactComponent };